import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { IInputFieldArgs } from '@/modules/mixing/ts/rustmix-buyer.types';
import styles from './index.module.sass';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';
import { createWheelHandler } from '@/modules/helpers/create-wheel-handler/index.helper';

export const IdkInputField = ({ data, setValue, renewTotalData }: IInputFieldArgs) => {
  const handleWheel = createWheelHandler(
    data,
    setValue,
    { field: 'idk' },
    renewTotalData,
  );
  return (
    <InputWithSign
      float={true}
      inputClassName={styles.inpInner}
      className={styles.input}
      prefix=""
      label="ИДК"
      postfix=""
      value={data.idk}
      onClick={handleClick}
      onChange={(e: any) => {
        setValue && setValue({ ...data, idk: e.target.value.replace(/[^0-9.]/g, '') });
      }}
      onWheel={handleWheel}
      onBlur={renewTotalData}
    />
  );
};
